import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Button,
} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

import { BsPaperclip, BsCheck } from "react-icons/bs";
import { MdAdd, MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { useParams, Link, useNavigate } from "react-router-dom";

//Componentes
import Loading from "../../components/modales/loadingModal";
import HorizontalLabelPositionBelowStepper from "../../components/stepper/stepper";
import InfoCard from "../../components/cards/cardInfoSeccion";
import ModalCancelacion from "./componentes/modalCancelacion";
import DescargarAPEButton from "../../components/buttons/DescargarAPEButton";
import DescargarZIPButton from "../../components/buttons/DescargarZIPButton";

//Funciones
// import { handleFilesAdd, getItemsList } from '../../utils/azureStorage/upload';
import { getFinalFileZip } from "../../utils/FirebaseStorage/FirebaseStorage";
import { glosarioProceso1 } from "./utils/glosarioSolicitudes";
import LoadingModalTransparent from "../../components/modales/loadingModalTransparent";

//API Calls
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

const getAPE = functionsHttpsCallable("ape_getSolicitudPorId");
const editarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");
const exportarAPE = functionsHttpsCallable("ape_exportarSolicitud");
const envioCorreo = functionsHttpsCallable("correos_envioCorreoAPE");
//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

let VisualizadorSolicitudEmpleoHistorico = (props) => {
  const navigate = useNavigate();
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [data, setData] = useState([]);
  const [editAttachments, setEditAttachments] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [pasoActivo, setPasoActivo] = useState(0);
  const [pasos, setPasos] = useState([]);
  const [stateModalCancelacion, setStateModalCancelacion] = useState(false);
  const [userId, setUserId] = useState(true);
  const { id } = useParams();
  const { user, isAuthenticated, isLoading } = useAuth0();

  const listaAux = [
    { id: "auxilioAlimentacion", name: "Auxilio de Alimentación" },
    { id: "auxilioLocalizacion", name: "Auxilio de Localización" },
    { id: "auxilioMovilizacion", name: "Auxilio de Movilización" },
    { id: "auxilioMovilidad", name: "Auxilio de Movilización" },
    { id: "bonificacionCIS", name: "Bonificación C.I.S." },
    { id: "bonificacionSIS", name: "Bonificación S.I.S." },
    { id: "primaElSauceMansovar", name: "Prima El Sauce Mansovar" },
    { id: "primaHabitacionalCIS", name: "Prima Habitacional C.I.S." },
    {
      id: "primaAlimentacionYAlojamientoMasaro",
      name: "Prima Alimentacion y Alojamiento Mansaro",
    },
    { id: "auxilioGaitanSIS", name: "Auxilio Económico Gaitán S.I.S. Mensual" },
    {
      id: "auxilioConvencionalECP",
      name: "Auxilio Transporte Convecional ECP",
    },
    {
      id: "subsidioConvencionalHabitacion",
      name: "Subsidio Convencional Habitación",
    },
    { id: "auxilioTransporteConv", name: "Auxilio Transporte Conv." },
    {
      id: "bonificacionBeneficioBienestar",
      name: "Bonificación Beneficio de Bienestar",
    },
  ];

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      setUserId(user["http://localhost:3000/username"]);
    }
    async function getData() {
      setLoading(true);
      await getInformacionSolicitud();
      setLoading(false);
    }
    getData();
    document.title = "Detalle APE";
  }, []);

  useEffect(() => {
    async function getPasos() {
      await getPasosProceso();
    }
    getPasos();
  }, [data]);

  const cancelarSolicitud = () => {
    let newData = { ...data };
    newData.estadoAPE = "CANCELADA";
    setData(newData);
  };

  const downloadZip = async () => {
    setModalTransaction(true);
    try {
      await getFinalFileZip(`APEFiles/${id}`, props.usuarioActivo.userData);
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const downloadSolicitud = async () => {
    setModalTransaction(true);
    let body = {
      solicitudId: id,
    };
    try {
      let downloadLink = await exportarAPE(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const getInformacionSolicitud = async () => {
    let body = {
      solicitudId: id,
      cod_empr: userData.codigoEmpresa,
    };
    const APEInfo = await getAPE(body);
    if (APEInfo.data.status !== "CONSULTA_EXITOSA") {
      toastError("Hubo un problema con la solicitud");
      navigate("/home/procesos");
    }
    const tempData = APEInfo.data.data;
    tempData["salario"] = parseInt(APEInfo.data.data.salario).toLocaleString();
    setData(tempData);
  };

  const getHoursLeft = () => {
    let fechaActual = new Date(Date.now());
    let fechaComparacion;
    if (fechaActual.getDay() === 6) {
      fechaComparacion = new Date(
        data.fechaCreacion._seconds * 1000 + 65 * 60 * 60 * 1000
      );
    } else if (fechaActual.getDay() === 7) {
      fechaComparacion = new Date(
        data.fechaCreacion._seconds * 1000 + 89 * 60 * 60 * 1000
      );
    } else {
      fechaComparacion = new Date(
        data.fechaCreacion._seconds * 1000 + 41 * 60 * 60 * 1000
      );
    }
    let validacion = fechaComparacion.getTime() < fechaActual.getTime();
    let hora =
      Math.abs(fechaComparacion.getTime() - fechaActual.getTime()) / 3600000;
    let hh = parseInt(hora);
    let mm = parseInt((hora - parseInt(hora)) * 60);
    return validacion
      ? `Vencida`
      : `TIEMPO RESTANTE PARA APROBACION DE LA APE: ${hh} horas ${mm} minutos`;
  };

  const getPasoActivo = () => {
    let pasoActivo = 0;
    Object.keys(glosarioProceso1).forEach((key, index) => {
      if (glosarioProceso1[key].id === data.estadoAPE) {
        pasoActivo = index;
      } else if (glosarioProceso1[key].steps) {
        if (glosarioProceso1[key].steps.includes(data.estadoAPE)) {
          pasoActivo = index;
        }
      }
    });
    setPasoActivo(pasoActivo);
  };

  const getPasosProceso = async () => {
    setLoading(true);
    let pasosTemp = [];
    for (let step of glosarioProceso1) {
      if (
        !(step.id === "APROBACION4" && data.tipoContractual === "CONTRACTUAL")
      ) {
        if (step.id === "SOLICITADO") {
          pasosTemp.push(`${step.name} - ${data[`${step.key}`]}`);
        } else if (data.flujo[step.key] !== undefined) {
          console.log("aca", step.key);
          pasosTemp.push(`${step.name} - ${data.flujo[`${step.key}`]}`);
        }
      }
    }
    setPasos(pasosTemp);
    getPasoActivo();
    setLoading(false);
  };

  const toggleModalCancelacion = () =>
    setStateModalCancelacion(!stateModalCancelacion);

  const getFechaAprobacion = (estado) => {
    let tempData = {};
    switch (estado) {
      case "RECLUTADOR":
        if (
          data.estadoAPE === "APROBACION3" &&
          data.tipoContractual === "CONTRACTUAL"
        ) {
          tempData["fec_recl"] = new Date(Date.now()).toISOString();
          tempData["fec_apr3"] = new Date(Date.now()).toISOString();
        } else {
          tempData["fec_recl"] = new Date(Date.now()).toISOString();
          tempData["fec_apr4"] = new Date(Date.now()).toISOString();
        }
        break;
      case "APROBACION3":
        tempData["fec_apr2"] = new Date(Date.now()).toISOString();
        break;
      case "APROBACION4":
        tempData["fec_apr3"] = new Date(Date.now()).toISOString();
        break;
      case "APROBACION2":
      default:
        tempData["fec_apr1"] = new Date(Date.now()).toISOString();
        break;
    }
    return tempData;
  };

  const auxilios = [
    { id: "auxilioAlimentacion", name: "Auxilio de Alimentación" },
    { id: "auxilioLocalizacion", name: "Auxilio de Localización" },
    { id: "auxilioMovilizacion", name: "Auxilio de Movilización" },
    { id: "bonificacionCIS", name: "Bonificación C.I.S." },
    { id: "bonificacionSIS", name: "Bonificación S.I.S." },
    { id: "primaElSauceMansovar", name: "Prima El Sauce Mansovar" },
    { id: "primaHabitacionalCIS", name: "Prima Habitacional C.I.S." },
    {
      id: "primaAlimentacionYAlojamientoMasaro",
      name: "Prima Alimentacion y Alojamiento Mansaro",
    },
    { id: "auxilioGaitanSIS", name: "Auxilio Económico Gaitán S.I.S. Mensual" },
    {
      id: "auxilioConvencionalECP",
      name: "Auxilio Transporte Convecional ECP",
    },
    {
      id: "subsidioConvencionalHabitacion",
      name: "Subsidio Convencional Habitación",
    },
    { id: "auxilioTransporteConv", name: "Auxilio Transporte Conv." },
    {
      id: "bonificacionBeneficioBienestar",
      name: "Bonificación Beneficio de Bienestar",
    },
    { id: "auxCaminanteNoSalarial", name: "AUXILIO DE CAMINANTE NO SALARIAL" },
    { id: "auxNoSalarialCasino", name: "AUXILIO NO SALARIAL CASINO" },
    {
      id: "auxProduccionYCampoSIS",
      name: "AUXILIO DE PRODUCCION Y DE CAMPO S.I.S",
    },
    { id: "auxAlimentacionDiario", name: "AUXILIO ALIMENTACION DIARIO S.I.S" },
    { id: "auxMovilizacionDiario", name: "AUXILIO MOVILIZACION DIARIO S.I.S" },
    { id: "auxLocalizacionDiario", name: "AUXILIO LOCALIZACION DIARIO S.I.S" },
    { id: "auxLoncheSIS", name: "AUXILIO POR LONCHE S.I.S" },
    {
      id: "auxEspecialTransporteSIS",
      name: "AUXILIO ESPECIAL DE TRANSPORTE SIS",
    },
    {
      id: "auxEspecialAlimentacionSIS",
      name: "AUXILIO ESPECIAL DE ALIMENTACION SIS",
    },
    { id: "auxEspecialLejanias", name: "AUXILIO ESPECIAL DE LEJANIAS" },
    {
      id: "auxNoSalarialBloqueMatambo",
      name: "AUXILIO NO SALARIAL BLOQUE MATAMBO",
    },
    {
      id: "auxNoSalarialBloqueCampoRico",
      name: "AUXILIO NO SALARIAL BLOQUE CAMPO RICO",
    },
    { id: "auxViaticosTSA", name: "AUXILIO POR VIATICOS TSA" },
    {
      id: "auxTrabajoRemotoUtipecSIS",
      name: "AUXILIO TRABAJO REMOTO UTIPEC SIS",
    },
    {
      id: "auxNoSalarialBloqueMaranta",
      name: "AUXILIO NO SALARIAL BLOQUE MARANTA",
    },
    {
      id: "auxAlimentacionDiarioCIS",
      name: "AUXILIO ALIMENTACION DIARIO C.I.S",
    },
    { id: "auxViaticosEMO", name: "AUXILIO POR VIATICOS EMO" },
    {
      id: "auxEconomicoObrasMetalMecanica",
      name: "AUXILIO ECONOMICO OBRAS METALMECANICA",
    },
    { id: "auxTransporteDiarioSIS", name: "AUXILIO DE TRANSPORTE DIARIO SIS" },
  ];

  const getActiveStepAge = (updateDate) => {
    const now = new Date(Date.now());
    const age =
      (now.getTime() - new Date(updateDate).getTime()) / (24 * 60 * 60 * 1000);
    return age ?? 0;
  };

  if (loading || data.length === 0) {
    return (
      <div className={"loading-area"}>
        {" "}
        <Loading />{" "}
      </div>
    );
  } else {
    return (
      <div className="visualizador-ape">
        <LoadingModalTransparent isOpen={modalTransaction} />
        <Toaster />
        <ModalCancelacion
          toggle={toggleModalCancelacion}
          modal={stateModalCancelacion}
          action={cancelarSolicitud}
          id={id}
          data={data}
        />
        <Breadcrumb>
          <BreadcrumbItem active>
            <Link to={"/home/historico"}>Solicitudes</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Solicitud N° {id}</BreadcrumbItem>
        </Breadcrumb>
        <div className="breadcum-display-content-2">
          <DescargarAPEButton
            onClick={() => {
              downloadSolicitud();
            }}
          />
          <DescargarZIPButton
            onClick={() => {
              downloadZip();
            }}
          />
        </div>
        <div>
          <InfoCard title={"Estado Proceso"}>
            <HorizontalLabelPositionBelowStepper
              steps={pasos}
              activeStep={pasoActivo}
            />
          </InfoCard>
        </div>
        <br />
        <InfoCard title={"1. Tipo de Vacante"}>
          <Row>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Vacante</Label>
              <Input
                type="text"
                name="text"
                id="inputVacante"
                readOnly
                defaultValue={data.tipoVacante}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cargo</Label>
              <Input
                type="text"
                name="text"
                id="inputCargo"
                readOnly
                defaultValue={data.codigoCargo}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Cantidad de Vacantes</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.numeroPlazas}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Proceso/Area</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.proceso}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Trabajador a Reemplazar</Label>
              <Input
                type="text"
                name="text"
                id="inputTrabajadorReemp"
                readOnly
                defaultValue={data.trabajadorReemplazar}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"2. Origen del Cargo"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Contractual/No Contractual</Label>
              <Input
                type="text"
                name="text"
                id="inputContractual"
                readOnly
                defaultValue={data.tipoContractual}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cliente Comercial</Label>
              <Input
                type="text"
                name="text"
                id="inputClienteCom"
                readOnly
                defaultValue={data.clienteComercial}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">N° de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputNumContrato"
                readOnly
                defaultValue={data.numeroContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Ítem de Cobro</Label>
              <Input
                type="text"
                name="text"
                id="inputItemCobro"
                readOnly
                defaultValue={data.itemCobro}
              />{" "}
              {/* confirmar */}
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Código ATA</Label>
              <Input
                type="text"
                name="text"
                id="inputCodigoATA"
                readOnly
                defaultValue={data.codigoATA}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Centro de Costos</Label>
              <Input
                type="text"
                name="text"
                id="inputCentroCostos"
                readOnly
                defaultValue={data.centroCosto}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">*PEP</Label>
              <Input
                type="text"
                name="text"
                id="inputPep"
                readOnly
                defaultValue={data.PEP}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3. Condiciones Laborales"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Campo</Label>
              <Input
                type="text"
                name="text"
                id="inputCampo"
                readOnly
                defaultValue={data.campo}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Especialidad</Label>
              <Input
                type="text"
                name="text"
                id="inputEspecialidad"
                readOnly
                defaultValue={data.especialidad}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Duración del Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputDuracionContrato"
                readOnly
                defaultValue={data.duracionContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoContrato"
                readOnly
                defaultValue={data.tipoContrato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Nómina/Planilla</Label>
              <Input
                type="text"
                name="text"
                id="inputNomina"
                readOnly
                defaultValue={data.tipoNomina}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Salario</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoSalario"
                readOnly
                defaultValue={data.tipoSalario}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Salario Básico</Label>
              <Input
                type="text"
                name="text"
                id="inputSalario"
                readOnly
                defaultValue={data.salario ? data.salario : "$ 0"}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Jefe Inmediato</Label>
              <Input
                type="text"
                name="text"
                id="inputJefe"
                readOnly
                defaultValue={data.jefeInmediato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Funciones de Conductor</Label>
              <Input
                type="text"
                name="text"
                id="inputFuncionesConductor"
                readOnly
                defaultValue={data.funcionesConductor}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Turno/Régimen de Trabajo</Label>
              <Input
                type="text"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.turno}
              />
            </Col>
            {/* <Col lg='3' md='6' xs="12">
                            <Label for="exampleSelect">Auxilio de Alimentación</Label>
                            <Input type="text" name="text" id="inputAuxAlim" readOnly defaultValue={data.auxilioAlimentacion} />
                        </Col>
                        <Col lg='3' md='6' xs="12">
                            <Label for="exampleSelect">Auxilio de Localización</Label>
                            <Input type="text" name="text" id="inputLoc" readOnly defaultValue={data.auxilioLocalizacion} />
                        </Col> */}
            {auxilios.map((aux, index) => {
              if (data[aux.id] && data[aux.id] !== "0") {
                console.log(aux.id, data[aux.id]);
                return (
                  <Col lg="6" md="6" xs="12">
                    <Label for="exampleSelect">{`${aux.name}`}</Label>
                    {/* <Input type="text" name="text" id={`${aux.id}`} readOnly defaultValue={data[aux.id]} /> */}
                    <Input
                      type="text"
                      name="text"
                      id={`${aux.id}`}
                      readOnly
                      defaultValue={
                        data[aux.id]
                          ? parseInt(data[aux.id]).toLocaleString()
                          : "$ 0"
                      }
                    />
                  </Col>
                );
              }
            })}
          </Row>
          <Row xs="2">
            {/* <Col lg='3' md='6' xs="12">
                            <Label for="exampleSelect">Auxilio de Movilización</Label>
                            <Input type="text" name="text" id="inputAuxMov" readOnly defaultValue={data.auxilioMovilidad} />
                        </Col> */}
            {/* <Col lg='3' md='6' xs="12">
                            <Label for="exampleSelect">Otros Auxilios</Label>
                            <Input type="text" name="text" id="inputAuxOtro" readOnly defaultValue={data.aux_otro}/>
                        </Col>
                        <Col lg='3' md='6' xs="12">
                            <Label for="exampleSelect">Valor Otros Auxilios</Label>
                            <Input type="text" name="text" id="inputAuxOtro" readOnly defaultValue={data.aux_otrv}/>
                        </Col> */}
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Otros</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.otros}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Observaciones</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.observaciones}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3.1 Auxilios"}>
          <Row xs="2">
            {listaAux.map((aux) => {
              if (data[aux.id] !== undefined && data[aux.id] !== null) {
                return (
                  <Col lg="3" md="6" xs="12">
                    <Label for="exampleSelect">{aux.name}</Label>
                    <Input
                      type="text"
                      name="text"
                      id="inputSalario"
                      readOnly
                      defaultValue={data[aux.id] ? data[aux.id] : "$ 0"}
                    />
                  </Col>
                );
              }
            })}
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"4. Recursos"}>
          <Row xs="12">
            {data.recursos !== null &&
            data.recursos !== undefined &&
            data.recursos !== "" ? (
              data.recursos.map((recurso, index) => {
                return (
                  <Button
                    className="badge-attached-file"
                    key={`key_recurso_btn_${index}`}
                    outline
                    disabled
                    color="success"
                  >
                    {recurso}
                    <BsCheck size={16} />
                  </Button>
                );
              })
            ) : (
              <div className="ape-list-nodata-text">
                <p>No se asignó ningun recurso</p>
              </div>
            )}
          </Row>
        </InfoCard>
        <br />
      </div>
    );
  }
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(VisualizadorSolicitudEmpleoHistorico),
  {
    onRedirecting: () => <Loading />,
  }
);
